import React, { useCallback, useState } from 'react';
import { Box } from '@mui/material';
import './custom-offices.css';
import { IconAffiliate, IconEdit, IconPlus } from '@tabler/icons-react';
import { useOfficesCities } from '../../../hooks/OfficesCities/useOfficesCities';
import { SectionHeader, UIPageHeader } from '../../utilities/Headers';
import UITable, { UITableHeadCell } from '../../utilities/Table';
import { UIButton } from '../../utilities/Button';
import ModalOfficeCitiesAdmin from './modalOfficeCitiesAdmin';
import ModalOfficeCitiesConnectedAdmin from './modalOfficeCitiesConnectedAdmin';

const OfficesCitiesView = () => {
  const [selectedCity, setSelectedCity] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [connectedMode, setConnectedMode] = useState(false);
  const [forceUpdate, setForceUpdate] = useState(false);

  const { onListOfficesCitiesAdminPaginated } = useOfficesCities();

  const columns = [
    {
      name: <UITableHeadCell title={'Nome'} />,
      value: 'NameEl',
      size: 80
    },
    {
      name: '',
      value: 'actionsEl',
      size: 80
    }
  ];

  const prepareValues = (cities) =>
    cities?.map((city) => {
      return {
        city: city,
        NameEl: <Box>{city?.name}</Box>,
        actionsEl: (
          <Box width={'100%'} display={'flex'} alignItems={'center'} justifyContent={'flex-end'} mr={'15px'}>
            <UIButton
              type={'icon'}
              onClick={() => {
                setSelectedCity(city);
                setEditMode(true);
              }}
              icon={
                <IconEdit
                  stroke={'1.67px'}
                  style={{
                    width: '24px'
                  }}
                />
              }
            />
            <UIButton
              type={'icon'}
              onClick={() => {
                setSelectedCity(city);
                setConnectedMode(true);
              }}
              icon={
                <IconAffiliate
                  stroke={'1.67px'}
                  style={{
                    width: '24px'
                  }}
                />
              }
            />
          </Box>
        )
      };
    });

  const handleModalClose = useCallback(() => {
    setEditMode(false);
    setConnectedMode(false);
    setForceUpdate(true);
  }, []);

  return (
    <Box className="products-view" w={'100%'} h={'100%'} overflow={'auto'}>
      <Box
        position={'fixed'}
        display={'flex'}
        right={10}
        bottom={10}
        bgcolor={'#2c3e50'}
        p={'10px'}
        borderRadius={'100%'}
        w={'50px'}
        h={'50px'}
        color={'white'}
        justifyContent={'center'}
        alignItems={'center'}
        cursor={'pointer'}
        onClick={() => {
          setSelectedCity(null);
          setEditMode(true);
        }}
      >
        <IconPlus stroke={3} size="2rem" />
      </Box>

      <ModalOfficeCitiesAdmin modalOpen={editMode} handleModalClose={handleModalClose} city={selectedCity} />
      <ModalOfficeCitiesConnectedAdmin modalOpen={connectedMode} handleModalClose={handleModalClose} city={selectedCity} />

      <UIPageHeader
        title={'Città'}
        subtitle={'La lista delle città in cui sono presenti gli uffici. Puoi aggiungere, modificare o eliminare le città.'}
      />

      <SectionHeader title={'Città'} />
      <UITable
        columns={columns}
        prepareValues={prepareValues}
        enableSearch={true}
        infiniteScrollEndMessage={'Non ci sono altre città da mostrare'}
        infiniteScrollFunction={onListOfficesCitiesAdminPaginated}
        tableHeight={'calc(100vh - 450px)'}
        forceUpdate={forceUpdate}
        setForceUpdate={setForceUpdate}
        muiTableBodyRowProps={(data) => {
          return {
            sx: {
              bgcolor: data?.row?.original?.date ? '#FDF2B5' : '',
              p: 0,
              '& td': data?.row?.original?.date
                ? {
                    p: '5px 20px'
                  }
                : {}
            }
          };
        }}
      />
    </Box>
  );
};
export default OfficesCitiesView;
